<template>
  <v-row dense v-if="isDataLoaded">
    <v-col cols="12" xl="12">
      <v-sheet class="apexChartWrapper" :class="$vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-2'">
        <div class="chart-title-bar">
          <h3>Level Clients & Earnings</h3>
          <router-link class="links text--green pr-4" to="/transaction-history">See Details</router-link>
        </div>
        <div class="pt-3">
          <apexcharts width="100%" height="350" type="bar" :options="chartOptions" :series="series"></apexcharts>
        </div>
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
import { TRADINGACCOUNTSTOTRANSFER__ACTIONS } from "@/store/action-types";
import { mapState, mapActions } from "vuex";
import VueApexCharts from "vue-apexcharts";
export default {
  components: {
    apexcharts: VueApexCharts,
  },
  data() {
    return {
      isDataLoaded: false,
      chartOptions: {
        chart: {
          id: "basic-bar",
          type: "bar",
          toolbar: {
            show: false,
          },
        },
        xaxis: {
          categories: [
            "Jan.2024",
            "Feb.2024",
            "Mar.2024",
            "Apr.2024",
            "May.2024",
            "Jun.2024",
            "Jul.2024",
            "Aug.2024",
            "Sep.2024",
            "Oct.2024",
            "Nov.2024",
            "Dec.2024",
          ],
          axisBorder: {
            show: false,
          },
          labels: {
            style: {
              colors: ["#708AA7"],
              fontSize: "12px",
              fontFamily: "Inter",
              fontWeight: 500,
            },
          },
          axisTicks: {
            show: false,
            color: "transparent",
            height: 0,
            offsetX: 0,
            offsetY: 0,
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "75%",
            endingShape: "rounded",
          },
        },
        legend: {
          position: "top",
          horizontalAlign: "right",
          fontFamily: "Inter",
          fontSize: "14px",
          labels: {
            colors: "#708AA7",
            useSeriesColors: false,
          },
          markers: {
            width: 8,
            height: 8,
            radius: 8,
          },
        },
        yaxis: {
          labels: {
            formatter: (val) => {
              if (val < 1000) {
                return val.toFixed(0); // Show exact value for numbers below 1000
              }
              return (val / 1000).toFixed(1) + "K"; // Show with K format for 1000 and above
            },
            style: {
              colors: ["#708AA7"],
              fontSize: "12px",
              fontFamily: "Inter",
              fontWeight: 500,
            },
          },
          axisBorder: {
            show: false,
          },
        },
        colors: [
          "#307633",
          "#307676",
          "#436AA6",
          "#FF7BDA",
          "#FF6363",
          "#647630",
          "#7543B5",
          "#0E8CB4",
          "#50E18A",
          "#FFC163",
          "#6680B3",
          "#66991A",
        ],
        fill: {
          opacity: 0.5,
        },
        tooltip: {
           theme: 'dark',
          y: {
            formatter: function (val) {
              if (val < 1000) {
                return "$ " + val.toFixed(0);
              }
              return "$ " + (val / 1000).toFixed(1) + "K";
            }
          }
        },
        grid: {
          borderColor: "#1C2C40",
          strokeDashArray: 5,
          xaxis: {
            lines: {
              show: true,
            },
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 7,
          colors: ["transparent"],
        },
      },
      series: [],
    };
  },
  computed: {
    ...mapState("clientlevelearning", ["last12MonthsLevelData", "levels"]),
  },
  methods: {
    ...mapActions("clientlevelearning", [
      TRADINGACCOUNTSTOTRANSFER__ACTIONS.CLIENTLEVELEARNINGS,
    ]),
  },
  async mounted() {
    await this[TRADINGACCOUNTSTOTRANSFER__ACTIONS.CLIENTLEVELEARNINGS]();
    this.isDataLoaded = true;
    this.chartOptions.xaxis.categories = Object.keys(
      this.last12MonthsLevelData
    );
    this.series = this.levels.map((level) => {
      return {
        name: level,
        data: this.chartOptions.xaxis.categories.map((month) => {
          return this.last12MonthsLevelData[month][level] || 0;
        }),
      };
    });
  },
};
</script>
